export const LANDING_URL = import.meta.env.VITE_LANDING_URL || 'http://3asass.local:8000'
export const LOGISTICS_URL = import.meta.env.VITE_LOGISTICS_URL || 'http://logistics.local:8000'

/**
 * The customer portal in the logistics app. Its sign-in page hands a signed-in customer straight to
 * their home (or through this app's session if the logistics app has none yet), where the plain
 * logistics address would only land them on the public front page.
 */
export const CUSTOMER_PORTAL_URL = `${LOGISTICS_URL.replace(/\/$/, '')}/user/login`
